const deps = {};

/*---------------------------------------------------------*\
 * ArchivesController
\*---------------------------------------------------------*/
class ArchivesController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($timeout, navigationService, archiveService, localService, storageKeys) {
    deps.$timeout = $timeout;
    deps.navigationService = navigationService;
    deps.archiveService = archiveService;
    deps.localService = localService;
    deps.storageKeys = storageKeys;
    this.name = 'archives';

    this.updateArchives().then(() => {
      deps.$timeout(() => {
        if (this.currentStory) {
          // restore focus when coming back to home page
          deps.navigationService.focusElAsync('.main-content .story-list',
            this.currentStory.focusItem % this.storyPageSize);
          delete this.currentStory;
        } else {
          deps.navigationService.focusElAsync('.main-content');
        }
      });
    });
  }
  //-----------------------------------
  // Properties
  //-----------------------------------
  get region() {
    const _region = deps.localService.get(deps.storageKeys.selectedRegion);
    return _region ? _region.abbr : 'LI';
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  selectArchive(story, focusItem) {
    this.onSelect({ story, focusItem });
  }

  updateArchives() {
    return deps.archiveService.getArchives(this.region)
      .then((data) => {
        deps.$timeout(() => {
          this.archives = data;
        });
      });
  }
}

ArchivesController.$inject = ['$timeout', 'navigationService', 'archiveService', 'localService', 'storageKeys'];

export default ArchivesController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/archives/archives.controller.js
 **/